export default __webpack_public_path__ + "static/media/icon_bottom.afc8a5cf.png";